
export const COLOR = {
    white : "#fff",
    black : "#000",
    blue : "#3895FF",
    red : "#DF2935",
    yellow : "#FDCA40",
}